var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { "max-width": _vm.width } },
    [
      _c("v-select", {
        staticClass: "placeholder-black",
        attrs: {
          placeholder: `-- ${_vm.$t("select")} --`,
          outlined: "",
          "hide-details": "",
          "background-color": "#fff",
          "item-color": "ai",
          color: "#8509F6",
          items: _vm.items,
          height: "36px",
          dense: "",
          disabled: _vm.disabled,
          "menu-props": { offsetY: true, maxHeight: 350 },
        },
        on: {
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function ({ item }) {
              return [
                _c("span", { staticClass: "item font-outfit-light" }, [
                  _vm._v(_vm._s(item.text)),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }